import * as React from 'react';
import { usePortalConnections } from 'vet-bones/utils/portal';

import { Step, Stepper } from 'src/components/Stepper';
import { TEST_IDS } from 'src/constants/testIds';
import { hasValidMappingsSelector } from 'src/selectors/hasValidMappings';
import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const PUBLISH_PROJECT_DRAWER_STEPS = {
  connection:
    copy.components.publishProjectDrawer.connectionConfiguration
      .singleConnectionHeader,
  model: copy.components.publishProjectDrawer.modelConfiguration.header,
  mapping: copy.components.publishProjectDrawer.mappingConfiguration.header,
};

export type PublishProjectDrawerStep =
  keyof typeof PUBLISH_PROJECT_DRAWER_STEPS;

export type PublishProjectDrawerStepperProps = {
  active: PublishProjectDrawerStep | 'none';
};

export const PublishProjectDrawerStepper = ({
  active,
}: PublishProjectDrawerStepperProps) => {
  const PUBLISH_PROJECT_DRAWER_STEPS_COPY = { ...PUBLISH_PROJECT_DRAWER_STEPS };
  const { projectId } = useRouterParams();
  const hasValidMappings = useReduxSelector(
    hasValidMappingsSelector(projectId)
  );
  const connections = usePortalConnections();

  if (connections.data && connections.data.length > 1) {
    PUBLISH_PROJECT_DRAWER_STEPS_COPY.connection =
      copy.components.publishProjectDrawer.connectionConfiguration.header;
  }

  let disabled = false;
  return (
    <Stepper testId={TEST_IDS.publishProjectDrawer.stepper}>
      {(
        Object.entries(PUBLISH_PROJECT_DRAWER_STEPS_COPY) as Array<
          [PublishProjectDrawerStep, string]
        >
      ).map(([key, title]) => {
        if (!hasValidMappings && key === 'mapping') {
          return null;
        }
        const isActive = key === active;
        if (isActive) {
          // disable all steps after the active step
          disabled = true;
        }
        return (
          <Step
            key={key}
            active={isActive}
            disabled={!isActive && disabled}
            title={title}
          />
        );
      })}
    </Stepper>
  );
};
